import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilegrantLogoWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 58,
	viewBox: "0 0 57 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M55.3803 15.504C55.3803 8.05099 49.3648 2 41.9554 2H14.9248C7.5155 2 1.5 8.05099 1.5 15.504V42.5121C1.5 49.9652 7.5155 56.0162 14.9248 56.0162H41.9554C49.3648 56.0162 55.3803 49.9652 55.3803 42.5121V15.504Z",
			stroke: "white",
			strokeWidth: 2.90838
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.4522 23.7149C31.3879 17.9706 26.0446 6.11523 26.0446 6.11523C24.6279 7.18481 21.4953 11.7857 24.3232 18.6819C25.5751 21.735 27.2057 23.6029 28.6343 24.7367C23.4442 24.3757 14.0152 23.6854 7.43291 23.1993C7.21817 24.3051 6.52302 26.9422 4.47656 29.8306C8.82957 33.4663 14.6371 33.7818 14.6371 33.7818C25.2276 34.3974 28.6682 30.9368 28.6682 30.9368C29.2912 33.9006 28.6188 36.8089 27.4472 40.0162C27.0349 41.1448 25.2235 44.0876 23.3598 47.1155L23.3598 47.1155C21.3717 50.3455 19.3239 53.6724 18.8513 54.9972H36.6596C35.134 50.8552 37.5693 41.149 38.0602 39.5415C38.0835 39.4654 38.1085 39.3844 38.1349 39.2987C38.7383 37.3425 40.0937 32.9483 38.5545 29.1435C38.1467 28.1354 37.547 27.3706 36.879 26.7906C39.4018 26.9656 42.8763 26.5105 46.0843 23.5428C50.0931 19.8344 50.8861 16.2455 50.9732 14.2941C50.976 14.2923 50.9789 14.2904 50.9817 14.2886C50.9823 14.2123 50.9818 14.1395 50.9804 14.0703C50.9814 14.0169 50.9819 13.965 50.9819 13.9145C50.9799 13.9158 50.9778 13.9172 50.9757 13.9185C50.9562 13.44 50.8974 13.1717 50.8974 13.1717C48.0133 14.4233 38.4214 20.5161 33.4522 23.7149Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.06713 23.1338C6.85887 24.2342 6.19265 26.7988 4.20472 29.6733C2.30599 28.0508 0.692747 25.7624 0 22.5391L7.06713 23.1338Z",
			fill: "#FF0060"
		})
	]
});
export default SvgFilegrantLogoWhite;
